import React from 'react'
import PropTypes from 'prop-types'
import {
  Wrapper,
  Header,
  HeaderInner,
  Main,
  Footer,
  FooterInner,
} from './LandingLayout.styles'

const LandingLayout = ({ children, header = null, footer = null }) => {
  return (
    <Wrapper>
      {header && (
        <Header>
          <HeaderInner>{header}</HeaderInner>
        </Header>
      )}
      <Main>{children}</Main>
      {footer && (
        <Footer>
          <FooterInner>{footer}</FooterInner>
        </Footer>
      )}
    </Wrapper>
  )
}

LandingLayout.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  header: PropTypes.node,
}

export default LandingLayout
